import { Router } from "./routes/Router";

export function App() {
  return <Router />;
}
